import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-play-learn-info',
  templateUrl: './play-learn-info.component.html',
  styleUrls: ['./play-learn-info.component.scss']
})
export class PlayLearnInfoComponent {
    @Input() heading = '';
    @Input() headingHtml = '';
    @Input() text = '';
    @Input() textHtml = '';
}
